import React from 'react';
import { useTranslation } from '../i18n';
import { SUPPORT_HREF } from './ChoosePlanScreen';
// Trimmed, transparent export of the high-res wordmark (logo.png carries
// a wide white margin, so sizing it by height alone leaves a tiny mark).
import wordmark from '../assets/logo-wordmark.png';

/**
 * The two non-plan states of the subscription wall:
 *   loading     — neutral shell while /api/billing/access-state resolves
 *                 (the dashboard never flashes before access is known).
 *   unavailable — the server could not confirm the subscription and the
 *                 shop is outside its verified-active grace window: a
 *                 "try again" card with Contact support. Never the dashboard.
 */
const card = {
  maxWidth: 460,
  width: '100%',
  background: 'white',
  border: '1px solid #EAEBEE',
  borderRadius: 16,
  padding: '40px 32px',
  textAlign: 'center',
  boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
};
const wrap = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '70vh',
  padding: 24,
};

export function AccessLoadingScreen() {
  const { t } = useTranslation();
  return (
    <div style={wrap} className="au-access-loading" data-testid="access-loading" aria-busy="true" aria-live="polite">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', color: '#6d7175', fontSize: 14 }}>
        {/* Height-only sizing keeps the wordmark's natural aspect ratio. */}
        <img
          src={wordmark}
          alt="Autonoma AI"
          style={{ height: 40, width: 'auto', maxWidth: '70vw', objectFit: 'contain', flexShrink: 0, display: 'block' }}
        />
        <span className="au-cta__spinner au-access-loading__spinner" aria-hidden="true" />
        <div>{t('plans.checkingAccess')}</div>
      </div>
    </div>
  );
}

export function AccessUnavailableScreen({ message, onRetry, retrying = false }) {
  const { t } = useTranslation();
  return (
    <div style={wrap} data-testid="access-unavailable">
      <div style={card} role="alert">
        <div style={{ fontSize: 44, marginBottom: 12 }} aria-hidden="true">⏳</div>
        <h2 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 8px' }}>{t('plans.unavailableTitle')}</h2>
        <p style={{ fontSize: 14, color: '#5c5f62', margin: '0 0 24px', lineHeight: 1.5 }}>
          {message || t('plans.unavailableBody')}
        </p>
        <button
          type="button"
          data-testid="access-retry"
          onClick={onRetry}
          disabled={retrying}
          style={{
            border: 'none',
            borderRadius: 10,
            padding: '13px 28px',
            fontSize: 15,
            fontWeight: 700,
            fontFamily: 'inherit',
            color: 'white',
            background: 'var(--autonoma-gradient)',
            cursor: retrying ? 'default' : 'pointer',
            opacity: retrying ? 0.7 : 1,
          }}
        >
          {retrying ? t('plans.checking') : t('plans.tryAgain')}
        </button>
        <p style={{ fontSize: 13, marginTop: 20 }}>
          <a href={SUPPORT_HREF} data-testid="access-contact-support">{t('plans.contactSupport')}</a>
        </p>
      </div>
    </div>
  );
}
